module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "LegalCaseWorkflow"
    }
  }, [_c('modal', {
    attrs: {
      "transition": "modal fade",
      "title": _vm.modalTitle,
      "large": "",
      "force": ""
    },
    on: {
      "ok": function($event) {
        return _vm.ok()
      },
      "cancel": function($event) {
        return _vm.cancel()
      }
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectAll),
      expression: "selectAll"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.selectAll) ? _vm._i(_vm.selectAll, null) > -1 : (_vm.selectAll)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.selectAll,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.selectAll = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.selectAll = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.selectAll = $$c
        }
      }, _vm.setSelectAll]
    }
  }), _vm._v("\n            Select All\n            ")]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.includeStatementOfFacts),
      expression: "includeStatementOfFacts"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.includeStatementOfFacts) ? _vm._i(_vm.includeStatementOfFacts, null) > -1 : (_vm.includeStatementOfFacts)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.includeStatementOfFacts,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.includeStatementOfFacts = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.includeStatementOfFacts = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.includeStatementOfFacts = $$c
        }
      }
    }
  }), _vm._v("\n            Statement of Facts\n            ")]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.includeCaseInformationForm),
      expression: "includeCaseInformationForm"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.includeCaseInformationForm) ? _vm._i(_vm.includeCaseInformationForm, null) > -1 : (_vm.includeCaseInformationForm)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.includeCaseInformationForm,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.includeCaseInformationForm = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.includeCaseInformationForm = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.includeCaseInformationForm = $$c
        }
      }
    }
  }), _vm._v("\n            Case Information Form\n            ")]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.includeOffencesOffendersRoi),
      expression: "includeOffencesOffendersRoi"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.includeOffencesOffendersRoi) ? _vm._i(_vm.includeOffencesOffendersRoi, null) > -1 : (_vm.includeOffencesOffendersRoi)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.includeOffencesOffendersRoi,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.includeOffencesOffendersRoi = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.includeOffencesOffendersRoi = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.includeOffencesOffendersRoi = $$c
        }
      }
    }
  }), _vm._v("\n            Offences, Offenders and Records of Interview\n            ")]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.includeWitnessOfficerOtherStatements),
      expression: "includeWitnessOfficerOtherStatements"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.includeWitnessOfficerOtherStatements) ? _vm._i(_vm.includeWitnessOfficerOtherStatements, null) > -1 : (_vm.includeWitnessOfficerOtherStatements)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.includeWitnessOfficerOtherStatements,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.includeWitnessOfficerOtherStatements = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.includeWitnessOfficerOtherStatements = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.includeWitnessOfficerOtherStatements = $$c
        }
      }
    }
  }), _vm._v("\n            Witness Statements, Officer Statements, Expert Statements\n            ")]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.includePhysicalArtifacts),
      expression: "includePhysicalArtifacts"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.includePhysicalArtifacts) ? _vm._i(_vm.includePhysicalArtifacts, null) > -1 : (_vm.includePhysicalArtifacts)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.includePhysicalArtifacts,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.includePhysicalArtifacts = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.includePhysicalArtifacts = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.includePhysicalArtifacts = $$c
        }
      }
    }
  }), _vm._v("\n            List of Exhibits, Sensitive Unused and Non-Sensitive Unused Materials\n            ")]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.includeDocumentArtifacts),
      expression: "includeDocumentArtifacts"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.includeDocumentArtifacts) ? _vm._i(_vm.includeDocumentArtifacts, null) > -1 : (_vm.includeDocumentArtifacts)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.includeDocumentArtifacts,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.includeDocumentArtifacts = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.includeDocumentArtifacts = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.includeDocumentArtifacts = $$c
        }
      }
    }
  }), _vm._v("\n            List of Photographic Exhibits\n            ")])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.errorResponse) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('strong', [_vm._v("Error: " + _vm._s(_vm.errorResponse))])])])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.ok
    }
  }, [_vm._v("Ok")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8715e980"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/internal/legal_case/generate_document.vue
// module id = 1028
// module chunks = 0